// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-step-editor-sidebar-advanced-link-notification__close[data-v-5af6dd50]{background:transparent}", ""]);
// Exports
module.exports = exports;
